import { doesExist } from "@shared/backend/entity-security/does-exist";
import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { OrganizationManager } from "../organization-manager/entity";
import { type OrganizationManagerNotification } from "./entity";

export const OrganizationManagerNotificationEntityConfig: HyperEntityConfig<OrganizationManagerNotification> =
{
  allowApiCrud: Roles.AdminsAndManager,
  allowApiRead: Roles.AdminsAndManager,
  apiPrefilterPerRole: (filter) => {
    if (!remult.user) return;
    filter(Roles.AdminsAndManager, {
      toId: remult.user?.id,
    });
  },
  allowInsertPerRole: (allow) => {
    // Allow managers/admins to create notifications for themselves
    allow(Roles.AdminsAndManager, {
      toId: remult.user?.id,
    });

    // Allow admins/super admins to create notifications for other managers in the same organization
    allow(Roles.Admins, async (entity) => {
      if (!remult.user?.organizationId) return false;
      return doesExist(OrganizationManager, {
        id: entity.toId,
        organization: {
          $id: remult.user.organizationId,
        },
      });
    });

    allow(Roles.SuperAdmin, async (entity) => {
      if (!remult.user?.organizationId) return false;
      return doesExist(OrganizationManager, {
        id: entity.toId,
        organization: {
          $id: remult.user.organizationId,
        },
      });
    });
  },
  allowUpdatePerRole: (allow) => {
    allow(Roles.AdminsAndManager, {
      toId: remult.user?.id,
    });
  },
};
